import { AnyAction } from "redux";
import { GET_VENDOR_LOCKER_LIST_FAILURE, GET_VENDOR_LOCKER_LIST_REQUEST, GET_VENDOR_LOCKER_LIST_SUCCESS, RESET_VENDOR_LOCKER_LIST_STATE } from "../constants/vendorLockerList.constants";

const initialState = {
    loading: false,
    data: [],
    error: '',
};

export const vendorLockerListReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case GET_VENDOR_LOCKER_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_VENDOR_LOCKER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                errorMsg: '',
            };
        case GET_VENDOR_LOCKER_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };

        case RESET_VENDOR_LOCKER_LIST_STATE:
            return {
                ...initialState
            }

        default:
            return state;
    }
}